/**
 * Responsibility: Implement world object behavior for the engine layer.
 * Scope: Owns engine-layer concerns only; cross-layer orchestration is excluded.
 */
// ============================================================
// ENGINE/ENTITIES/WORLD-OBJECT.TS — Base game entity
// All interactive world objects derive from this abstract class.
// ============================================================

export abstract class WorldObject {
  /** Unique identifier for this object (name, identity, etc.). */
  abstract get id(): string
  /** Produce a textual examination of this object. */
  abstract examine(): string
}
